import React from 'react';
import { Card, Form, Table } from 'react-bootstrap';
import { ClaimFinancialField } from './ClaimFinancialField';
import { FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
import ChangeHighlightedImmutableUnderReviewControl from '@rd-web-markets/shared/dist/util/reviewEditControls/ChangeHighlightedImmutableUnderReviewControl';
export default function ClaimFieldsTable(_ref) {
  let {
    calculations,
    claim,
    setClaim,
    title,
    rows,
    refreshCalculations
  } = _ref;
  const filteredRows = rows.filter(row => row.shouldDisplay === undefined || !!row.shouldDisplay);
  const renderFieldValue = (row, fieldAttribute) => {
    const fieldName = row[fieldAttribute].name;
    if (calculations[fieldName]) {
      const fieldValue = calculations[fieldName];
      const formattedValue = typeof fieldValue === 'number' ? Number(fieldValue).toFixed(2) : typeof fieldValue === 'string' && !isNaN(fieldValue) ? Number(fieldValue).toFixed(2) : fieldValue;
      const inputType = parseFloat(fieldValue) ? 'number' : 'text';
      const AsComponents = {
        text: Form.Control,
        number: FormattedNumberInput
      };
      const AsComponent = AsComponents[inputType];
      return /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
        as: AsComponent,
        object: {
          ...calculations,
          claim: {
            ...calculations
          }
        },
        disabled: true,
        name: fieldName,
        type: "text",
        size: "sm",
        "data-testid": `benefit-calculations-${fieldName}`,
        style: {
          textAlign: 'right'
        },
        value: formattedValue
      });
    } else if (fieldName === null) {
      return /*#__PURE__*/React.createElement(React.Fragment, null);
    }
    const isEditable = row[fieldAttribute].editable;
    return /*#__PURE__*/React.createElement(ClaimFinancialField, {
      size: "sm",
      claim: claim,
      setClaim: setClaim,
      fieldName: fieldName,
      disabled: !isEditable,
      style: {
        width: '176px',
        textAlign: 'right'
      },
      onClaimUpdateSuccess: refreshCalculations
    });
  };
  const tableContainsRowWith2CostFields = rows.some(row => 'field_2' in row);
  const tableContainsRowWithSingleCostField = rows.some(row => 'field' in row);
  const rowsWithSingleFieldShouldHaveWiderText = tableContainsRowWith2CostFields && tableContainsRowWithSingleCostField;
  const singleCostFieldRowLeftColSpan = rowsWithSingleFieldShouldHaveWiderText ? 2 : 1;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Header, {
    className: "bg-secondary text-primary"
  }, title), /*#__PURE__*/React.createElement(Table, {
    striped: true
  }, /*#__PURE__*/React.createElement("tbody", null, filteredRows.map((row, index) => /*#__PURE__*/React.createElement("tr", {
    key: index
  }, /*#__PURE__*/React.createElement("td", {
    className: `${row.className || ''}`,
    colSpan: 'field' in row ? singleCostFieldRowLeftColSpan : 1
  }, row.text || row.render()), 'field_1' in row && /*#__PURE__*/React.createElement("td", {
    style: {
      width: '200px'
    },
    className: "text-right"
  }, renderFieldValue(row, 'field_1'), " "), 'field_2' in row && /*#__PURE__*/React.createElement("td", {
    style: {
      width: '200px'
    },
    className: "text-right"
  }, renderFieldValue(row, 'field_2'), " "), 'field' in row && /*#__PURE__*/React.createElement("td", {
    style: {
      width: '200px'
    },
    className: "text-right"
  }, renderFieldValue(row, 'field'), " ")))))));
}